module.exports = __webpack_public_path__ + "img/pxch-logo.d6866e3e.png";